// filepath: apps/web/src/features/admin/templates/registry/InstallSuccessToast.tsx
//
// FR-UI-ADM-11 AC-9 -- one-shot success toast after a successful
// install. Links to the FR-UI-PROM-2 review surface at
// /promote/review?reviewId=<seed_id> so the admin can immediately
// open the human-review gate for the new seed.

import React from "react";
import { useTranslation } from "@/i18n/useTranslation";

interface InstallSuccessToastProps {
  seedID: string;
  onClose: () => void;
  onOpenPromotion: () => void;
}

export function InstallSuccessToast({
  seedID,
  onClose,
  onOpenPromotion,
}: InstallSuccessToastProps): React.ReactElement {
  const { t } = useTranslation();
  return (
    <div
      className="fixed bottom-4 right-4 max-w-sm rounded border border-green-300 bg-green-50 p-4 text-sm text-green-900 shadow-lg"
      role="status"
      data-testid="template-registry-install-success-toast"
    >
      <div className="mb-2 font-medium">
        {t("admin.templates.registry.success.installed")}
      </div>
      <div className="mb-3 text-xs text-green-700">
        seed_id: <span className="font-mono">{seedID}</span>
      </div>
      <div className="flex items-center gap-2">
        <button
          type="button"
          onClick={onOpenPromotion}
          className="rounded bg-green-600 px-3 py-2 text-xs font-medium text-white hover:bg-green-700"
          data-testid="template-registry-install-success-review-link"
          style={{ minHeight: "48px" }}
        >
          {t("admin.templates.registry.success.installed.review_link")}
        </button>
        <button
          type="button"
          onClick={onClose}
          className="rounded border border-green-300 px-3 py-2 text-xs text-green-700 hover:bg-green-100"
          data-testid="template-registry-install-success-close"
          style={{ minHeight: "48px" }}
        >
          {t("common.close")}
        </button>
      </div>
    </div>
  );
}
